var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sweet-modal",
    {
      ref: "deleteSeriesModal",
      attrs: { icon: "warning" },
      on: {
        close: function($event) {
          return _vm.$emit("modal-close")
        }
      }
    },
    [
      _vm.selected !== null
        ? _c("div", { staticClass: "text-center" }, [
            _c("p", {
              staticClass: "mt-3",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("pages.admin.series.delete_confirmation", {
                    title: _vm.selected.title[_vm.$i18n.locale]
                  })
                )
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                on: { click: _vm.deleteSelected }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("actions.delete")) +
                    "\n        "
                )
              ]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }